import RequestPageTwo from "./RequestPageTwo";

const InternalRetreatReq = () => {
    return (
        <RequestPageTwo title="Internal Retreat Requests"
            fetchUrl="/get-internal-retreat-requests"
            editEndpoint="update-internal-retreat-requests"
            deleteEndpoint="-retreat-requests"
            statusEndpoint="update-internal-retreat-requests" />
    );
}

export default InternalRetreatReq;
